var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.817,
    height: 40.754,
    viewBox: "0 0 30.817 40.754",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_36780",
    "data-name": "Path 36780",
    d: "M17.747,38.387l-7.161,3.906a6.435,6.435,0,0,0-1.149.818,23.985,23.985,0,0,0,30.817.08,6.353,6.353,0,0,0-1.262-.846l-7.668-3.834A2.924,2.924,0,0,1,29.707,35.9V32.887a11.582,11.582,0,0,0,.725-.933,17.645,17.645,0,0,0,2.384-4.8,2.409,2.409,0,0,0,1.708-2.291V21.647a2.4,2.4,0,0,0-.8-1.78V15.225S34.675,8,24.891,8s-8.83,7.224-8.83,7.224v4.642a2.394,2.394,0,0,0-.8,1.78v3.211a2.408,2.408,0,0,0,1.11,2.021,15.937,15.937,0,0,0,2.9,6.007v2.934A2.927,2.927,0,0,1,17.747,38.387Z",
    transform: "translate(-9.437 -8.001)",
    fill: "#929292"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.b68682b49c6d0821b0e001b28c8f84b0.svg";
export { ForwardRef as ReactComponent };